import { useEnquireQuoteMutation } from "@/common/api/mutation";
import { useModal } from "@/common/contexts/Modal.context";
import { Button, Form, message } from "antd";
import TextArea from "antd/es/input/TextArea";
import GoToPageButton from "../ActionsButtons/GoToPageButton";
import StayInPageButton from "../ActionsButtons/StayInPageButton";
import InfoModal from "./Info.modal";
import { usePermissions } from "@/common/contexts/Permissions.context";
import Typography from "../Typography/Typography";

export default function EnquireQuoteModal({ data }: { data: any }) {
  const { closeModal, openModal } = useModal();
  const { company } = usePermissions();
  const quoteReqId = data.quoteReqId;
  const vendorId = data.price.companyId;
  const quoteLineId = data.id;
  const [form] = Form.useForm();
  const externalSubmit = () => {
    form.submit();
  };
  const { mutate } = useEnquireQuoteMutation();
  const onFinish = (values: any) => {
    if (!quoteReqId || !vendorId || !quoteLineId) {
      return message.error(
        "Something went wrong. Please reopen this modal or pick another option."
      );
    }
    const generatedEnquireData = {
      ...values,
      quoteLineId,
      vendorId,
      quoteReqId,
    };
    mutate(generatedEnquireData, {
      onSuccess: () => {
        closeModal();
        openModal(
          <InfoModal
            instruction={{
              behavior: "success",
              description: "",
              header: "Quote created",
            }}
            actions={[
              <StayInPageButton />,
              <GoToPageButton
                destinationName="Go to Quotes"
                link={
                  company.companyType === "customer"
                    ? "/customer/quotes/me"
                    : "/quotes"
                }
              />,
            ]}
          />
        );
      },
    });
  };
  return (
    <div>
      <Typography
        mb={6}
        type="p"
        textAlign="center"
        fontSize={20}
        textColor="black"
        fontWeight="font-medium"
        fontFamily="font-kanit"
      >
        Enquire
      </Typography>
      <div className="flex justify-between">
        <Typography
          mb={4}
          type="p"
          fontFamily="font-kanit"
          fontWeight="font-light"
        >
          Quote line ID:{data.priceId}
        </Typography>
      </div>
      <div className="flex flex-col gap-5">
        <Form form={form} onFinish={onFinish}>
          <div className="flex flex-col gap-1">
            <Typography
              type="span"
              fontFamily="font-kanit"
              fontWeight="font-light"
            >
              Description:
            </Typography>
            <Form.Item
              name={"description"}
              rules={[
                { required: true, message: "This field is required" },
                {
                  max: 256,
                  message: "Description cannot exceed 256 characters",
                },
              ]}
              children={
                <TextArea
                  className="!bg-gray-border text-base font-light font-kanit text-blackTransparent-60 p-4 border-none min-h-[400px] h-fit"
                  placeholder="Enter message here"
                  style={{
                    height: 404,
                    width: 475,
                    resize: "none",
                  }}
                />
              }
            />
          </div>
        </Form>
        <div className="flex justify-between gap-4">
          <Button
            onClick={() => closeModal()}
            className="text-base font-inter font-semibold h-10"
          >
            Back
          </Button>
          <Button
            onClick={externalSubmit}
            type="primary"
            className="text-base font-inter font-semibold h-10"
          >
            Send Custom Quote
          </Button>
        </div>
      </div>
    </div>
  );
}
